import {StyleParamType, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {numberMetadata} from '../../../../../utils/builderMetadata'

export type LayoutStylesParams = {
  horizontalPadding: StyleParamType.Number
  verticalPadding: StyleParamType.Number
}

export const layoutStyleParams = createStylesParams<LayoutStylesParams>({
  horizontalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 20 : 40),
    metadata: numberMetadata(StyleType.padding, {defaultValue: 40, mobileDefaultValue: 20}),
  },
  verticalPadding: {
    type: StyleParamType.Number,
    getDefaultValue: (params) => (params.isMobile ? 54 : 40),
    metadata: numberMetadata(StyleType.padding, {defaultValue: 40, mobileDefaultValue: 54}),
  },
})
